export const getUsers = state => state.users.users;
export const getSelectedUser = state => state.users.selectedUser;
export const getUsersPending = state => state.users.usersPending;
export const getUsersSuccess = state => state.users.usersSuccess;
export const getUsersFailure = state => state.users.usersFailure;
export const getUsersNext = state => state.users.next;



// WEBPACK FOOTER //
// ./src/redux/users/selectors.js